import type { Xinglet } from '@xing-com/crate-xinglet';

import { UserBagPageByUsername } from './user-bag-page-by-username';

export default class UserBagByUsername implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <UserBagPageByUsername />;
  }
}
